import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Brain, Zap, Activity } from 'lucide-react';
const features = [{
  icon: BookOpen,
  title: '60-Page Strategic Manual',
  description: 'The definitive roadmap for elite physical and mental output.'
}, {
  icon: Brain,
  title: 'Neuro-Clarity Protocols',
  description: 'How to maintain unbreakable focus even when the year-end stress starts to build.'
}, {
  icon: Zap,
  title: 'Dopamine Deep-Clean',
  description: 'Reset your motivation levels and eliminate the distractions that sabotaged your first half.'
}, {
  icon: Activity,
  title: 'Hormonal Baseline Reset',
  description: 'Recover the natural "drive" that modern living has been stripping away.'
}];
export function ProductShowcase() {
  return <section className="py-24 px-4" data-id="element-49" data-mp="3v8fgur4a8grt">
      <div className="max-w-5xl mx-auto" data-id="element-50" data-mp="3vbthnuxashx5">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-51" data-mp="3q9ugmrp15x3d">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-52" data-mp="2e83jfhp8xlcu">
            The Biologic Edge: <br data-id="element-53" data-mp="2i9oqunj0h7fn" />
            <span className="text-green-400" data-id="element-54" data-mp="2ia8cofbs8fyy">
              Your Command Manual for the Rest of 2026
            </span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-55" data-mp="1lhuy5gzeyku1">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-zinc-900/80 border border-white/10 p-8 rounded-2xl hover:border-green-500/30 transition-colors group" data-id="element-56" data-mp="1qgekvjlu00ng" data-mpi={index}>
              <div className="bg-green-500/10 w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:bg-green-500/20 transition-colors" data-id="element-57" data-mp="25749r4i3dkbd">
                <feature.icon className="w-8 h-8 text-green-400" data-id="element-58" data-mp="2jxlb6nuq8a89" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-white" data-id="element-59" data-mp="2ex7eu32hmoq2">
                {feature.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-60" data-mp="1r8xp4q25lgtn">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}